import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import HeaderOne from '../Components/Header/HeaderOne'
import BannerOne from '../Components/Banner/BannerOne'
import CategoryOne from '../Components/Category/CategoryOne'
import DestinationOne from '../Components/Destination/DestinationOne'
import AboutOne from '../Components/About/AboutOne'
import TourOne from '../Components/Tour/TourOne'
import GalleryOne from '../Components/Gallery/GalleryOne'
import CounterOne from '../Components/Counter/CounterOne'
import TestimonialOne from '../Components/Testimonials/TestimonialOne'
import ContactOne from '../Components/Contact/ContactOne'
import SocialEmbedsOne from '../Components/Social/SocialEmbedsOne'
import FooterOne from '../Components/Footer/FooterOne'
import ScrollToTop from '../Components/ScrollToTop'

const SECTION_IDS = ['banner', 'destination', 'category', 'about', 'tour', 'gallery', 'counter', 'testimonial', 'watch-follow', 'contact', 'travel-with-dinesh', 'ape-pansala', 'urumaya', 'ranga-rata']

function HomeOne() {
    const { hash } = useLocation()

    useEffect(() => {
        if (hash) {
            const id = hash.replace('#', '')
            if (SECTION_IDS.includes(id)) {
                const el = document.getElementById(id)
                if (el) {
                    // Scroll to the requested section, then clear the URL hash
                    // so a refresh doesn't keep the same fragment stuck.
                    setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 100)
                    setTimeout(() => {
                        if (typeof window !== 'undefined') {
                            window.history.replaceState(
                                null,
                                '',
                                window.location.pathname + window.location.search
                            )
                        }
                    }, 600)
                }
            }
        }
    }, [hash])

    return (
        <div>
            <HeaderOne />
            <div id="banner"><BannerOne /></div>
            <div id="destination"><DestinationOne /></div>
            <div className="home-section-divider" aria-hidden="true" />
            <div id="category"><CategoryOne /></div>
            <div id="about"><AboutOne /></div>
            <div id="tour"><TourOne /></div>
            <div id="gallery"><GalleryOne /></div>
            <div id="counter"><CounterOne /></div>
            <div id="testimonial"><TestimonialOne /></div>
            <div id="watch-follow"><SocialEmbedsOne /></div>
            <div id="contact"><ContactOne /></div>
            <FooterOne />
            <ScrollToTop />
        </div>
    )
}

export default HomeOne
